import React from "react";
import FilterSidebarForm from "./FilterSidebarForm";
import { UseFormReturn } from "react-hook-form";
import { ResourceLibraryMetadataFilters } from "@/modules/hub/features/ResourceLibrary/api/getResourceLibraryMetadata/types";
import { PartnerNetworkFilterFormData } from "../../hooks/PartnerNetworkFilterFormSchema";
import { useIsMobile } from "@/hooks/use-mobile";
import MobileFilterSheet from "@/components/MobileFilterSheet/MobileFilterSheet";

interface FilterSidebarProps {
  form: UseFormReturn<PartnerNetworkFilterFormData>;
  filters: ResourceLibraryMetadataFilters | null;
  isLoading: boolean;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const FilterSidebar: React.FC<FilterSidebarProps> = ({
  form,
  filters,
  isLoading,
  isOpen,
  onOpenChange,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileFilterSheet isOpen={isOpen} onOpenChange={onOpenChange}>
        <FilterSidebarForm
          filters={filters}
          form={form}
          loading={isLoading}
          onSubmit={() => {}}
        />
      </MobileFilterSheet>
    );
  }

  return (
    <aside className="w-full h-full overflow-y-auto [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-sm dark:[&::-webkit-scrollbar-thumb]:bg-gray-600">
      <h2 className="text-base font-medium text-gray-900 dark:text-slate-100 mb-1 pl-2 pr-4">
        Filters
      </h2>
      <p className="text-sm text-gray-500 dark:text-slate-400 mb-4 pl-2 pr-4">
        Refine your partner search
      </p>
      <div className="space-y-3 pl-2 pr-4">
        <FilterSidebarForm
          filters={filters}
          form={form}
          loading={isLoading}
          onSubmit={() => {}}
        />
      </div>
    </aside>
  );
};
